import { Component, EventEmitter, Output } from '@angular/core';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';

export type Product3DToDesign = {
  name: string,
  image: string,
  description: string,
  footer: string,
  available: boolean
}

@Component({
  selector: 'app-product-selector',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './product-selector.component.html',
  styleUrl: './product-selector.component.scss'
})
export class ProductSelectorComponent {
  display: boolean = false;
  products: { name: string, description: string, image: string, footer: string, available: boolean }[] = [
    {
      name: 'PRODUCTS.INSOLES',
      description: 'PRODUCTS.INSOLES_DESCRIPTION',
      image: 'assets/images/3dproducts/insole.png',
      footer: 'Seleccionar',
      available: true
    },
    {
      name: 'PRODUCTS.AFO',
      description: 'PRODUCTS.AFO_DESCRIPTION',
      image: 'assets/images/3dproducts/afo.png',
      footer: 'Seleccionar',
      available: true
    },
    {
      name: 'PRODUCTS.SPINAL_BRACE',
      description: 'PRODUCTS.SPINAL_BRACE_DESCRIPTION',
      image: 'assets/images/3dproducts/spinal_brace.png',
      footer: 'Seleccionar',
      available: true
    }
  ];

  @Output() productSelected = new EventEmitter<any>();

  showDialog() {
    this.display = true;
  }

  onHide() {
    this.display = false;
  }

  selectProduct(product: any) {
    this.productSelected.emit(product);
    this.display = false;
  }
}
